import { PayoutStatus } from '@40seas/entities/payouts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const payoutStatusColorMapping = {
    [PayoutStatus.Done]: 'success',
    [PayoutStatus.Failed]: 'error',
    [PayoutStatus.InProgress]: 'info',
    [PayoutStatus.Pending]: 'default',
    [PayoutStatus.Canceled]: 'error',
    [PayoutStatus.Ready]: 'info',
    [PayoutStatus.Initiated]: 'info',
    [PayoutStatus.Deposited]: 'success',
} as { [key in PayoutStatus]: EnumColor };
